/**
 * Format a number as US currency (USD).
 *
 * Uses Intl.NumberFormat for locale-aware formatting with dollar sign,
 * thousands separators, and configurable decimal places.
 *
 * @param amount - The numeric value to format
 * @param options - Optional formatting configuration
 * @param options.fractionDigits - Number of decimal places (default: 0)
 * @returns Formatted currency string (e.g., "$1,234" or "$1,234.56")
 *
 * @example
 * formatCurrency(1234)                      // "$1,234"
 * formatCurrency(1234.567)                  // "$1,235" (rounded)
 * formatCurrency(1234.5, { fractionDigits: 2 }) // "$1,234.50"
 */
export function formatCurrency(
  amount: number,
  options?: { fractionDigits?: number },
): string {
  const fractionDigits = options?.fractionDigits ?? 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}

/**
 * Format value display - uses "X @ $Y" format for quantities > 1
 */
export function formatValueDisplay(
  quantity: number | undefined,
  unitPrice: number,
  totalFee: number,
): string {
  if (quantity && quantity > 1) {
    return `${quantity} @ ${formatCurrency(unitPrice)}`;
  }
  return formatCurrency(totalFee);
}
